export const defaultSettings = {
  osAppRoot: process.env.REACT_APP_OS_APP_ROOT,
  osApiRoot: process.env.REACT_APP_OS_API_ROOT,
  osScriptLocation: process.env.REACT_APP_OS_SCRIPT_LOCATION,
  osSdkKey: process.env.REACT_APP_OS_SDK_KEY,
  loginMethod: process.env.REACT_APP_OS_LOGIN_METHOD,
  osOrgId: String(process.env.REACT_APP_OS_ORG_ID),
  osToken: process.env.REACT_APP_OS_TOKEN,
}
